import styled from 'styled-components';

export const HeaderContainer = styled.header`
	height: 55svh;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;

	img {
		position: absolute;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
	}
`;

export const TitleContainer = styled.div`
	padding: 1rem 1rem 1rem;
	z-index: 1;
	color: var(--ion-color-primary-contrast);

	h1 {
		margin: 10px 0 5px;
		font-size: 28px;
	}

	p {
		margin: 0;
		font-size: 12px;
		//text-transform: uppercase;
		color: #ffffff;//var(--ion-color-light-shade);
		line-height: 1.4em;
		margin-bottom: 0.4em;
		:last-of-type {
			margin-bottom: 0em;
		}
	}

	svg {
		width: 1.5rem;
		height: 1.5rem;
		margin-right: 0.25rem;

		path {
			fill: #fff;
		}
	}
`;
